module.exports = __webpack_public_path__ + "media/components/country-flag/static/mz-e05638400afbf61dd8b26d65c6bc3354.svg";